export const colorMain = "var(--main-color)";
export const colorPrimary = "var(--primary-color)";
export const colorPrimaryAccent = "var(--primary-color--accent)";
export const colorMainAccent = "var(--main-color--accent)";
export const colorBg = "var(--bg-color)";
